export default {
  pageTitle: '分佣商品管理',
  programIntroduction: 'Affiliate项目介绍',
  storeDefaults: '店铺默认配置',
  storeDefaultsTip: '默认配置用于批量开启和新商品自动参与；修改后仅影响后续订单。',
  commissionRate: '佣金率',
  commissionRatePlaceholder: '1.0 - 20.0',
  defaultVoucher: '默认Affiliate券批次',
  voucherPlaceholder: '请选择Affiliate券批次',
  autoEnable: '新商品自动参与',
  saveDefaults: '保存默认配置',
  clearRate: '清空佣金率',
  productList: '商品分佣配置',
  closeFrequencyWarning: '滚动 30 天内关闭 Affiliate 商品 ≥ 3 次，该商品将 90 天内禁止开启 Affiliate 分佣。',
  saleableFilter: '商品是否可售',
  saleable: '可售',
  notSaleable: '不可售',
  statusFilter: '状态筛选',
  filterStatusAll: '全部',
  filterStatusClosingBuffer: '缓冲中',
  filterStatusNotEnabled: '未开启',
  filterStatusReopenBlocked: '已禁止',
  productTitle: '商品标题',
  productTitlePlaceholder: '请输入商品标题',
  listingId: 'Listing ID',
  listingIdPlaceholder: '请输入Listing ID',
  search: '查询',
  reset: '重置',
  batchEnable: '批量开启',
  batchRate: '批量修改佣金率',
  batchVoucher: '批量更换Affiliate券',
  batchClose: '批量关闭',
  product: '商品',
  salePrice: '当前售价',
  stock: '库存',
  fbkStock: 'FBK库存',
  nonFbkStock: '非FBK库存',
  voucher: 'Affiliate券批次',
  estimatedCommission: '预估佣金',
  estimatedCommissionTip: '仅按当前商品信息预估，不代表订单实际佣金。',
  status: '参与状态',
  effectiveCloseCount: '已关闭次数',
  updatedTime: '配置更新时间',
  operation: '操作',
  enable: '开启',
  updateRate: '修改佣金',
  replaceVoucher: '更换券',
  close: '关闭',
  withdrawClose: '撤回关闭',
  unavailable: '不可售',
  noConfig: '未配置',
  statusUnconfigured: '未配置',
  statusDisabled: '已关闭',
  statusEnabled: '已开启',
  statusClosingBuffer: '关闭缓冲期',
  statusReopenBlocked: '限制开启',
  closingDeadline: '预计关闭：{time}',
  reopenBlockedUntil: '可再次开启：{time}',
  configProduct: '配置并开启商品',
  updateProductRate: '修改商品佣金率',
  replaceProductVoucher: '更换商品Affiliate券',
  confirm: '确定',
  cancel: '取消',
  selectProducts: '请先选择商品',
  noAvailableProducts: '所选商品不支持该操作',
  invalidRate: '佣金率必须在1.0%到20.0%之间，且最多保留1位小数',
  selectVoucher: '请选择Affiliate券批次',
  autoEnableNeedsDefaults: '开启新商品自动参与前，请完整配置佣金率和默认Affiliate券批次',
  saveSuccess: '保存成功',
  operationSuccess: '操作成功',
  enableNotApplied: '商品未能开启Affiliate，列表已刷新，请查看当前参与状态后重试',
  confirmCloseTitle: '确认关闭Affiliate',
  confirmCloseContent: '关闭后将进入24小时缓冲期，缓冲期内仍可撤回。 关闭≥ 3 次时会立即封禁。确认继续吗？',
  confirmWithdrawTitle: '确认撤回关闭',
  confirmWithdrawContent: '撤回后商品将继续参与Affiliate。确认继续吗？',
  confirmBatchCloseTitle: '确认批量关闭Affiliate',
  confirmBatchCloseContent: '将对支持关闭的已选商品发起关闭申请，结果可能部分成功。确认继续吗？',
  batchOperation: '批量操作',
  batchResult: '批量操作结果',
  batchResultSummary: '成功 {success} 个，失败 {failure} 个',
  failureReason: '失败原因',
  message: '说明',
  versionConflict: '配置已被更新，页面已刷新，请基于最新数据重试',
  cpsForbidden: '当前店铺暂不可使用Affiliate功能',
  loadFailed: '数据加载失败',
  unknownError: '操作失败，请稍后重试',
  defaultNotConfigured: '店铺尚未保存默认配置',
  createCpsVoucher: '管理Affiliate券批次'
}
